<template>
  <main v-if="!content" class="main_inner flex-grow-1 loading" />
  <main v-else class="main_inner flex-grow-1">
    <!-- eslint-disable-next-line -->
        <div class="partner_area" v-html="content">
    </div>
  </main>
</template>

<script>
import { page } from '@/api/common'

export default {
  name: 'Vip',
  data() {
    return {
      content: false
    }
  },
  created() {
  },
  mounted() {
    page({ type: 'vip' })
      .then(response => {
        const reqData = response.data
        if (reqData && reqData.status === 200) {
          this.content = reqData.data.content
        }
      })
  }
}
</script>

<style scoped>
    div.partner_area img {
        max-width: 100% !important;
    }
</style>
